import io from 'socket.io-client';

export default {
  data: function () {
    return {
      hiveTwinSocket: null,
    };
  },
  destroyed() {
    this.teardownDtwinSocket();
  },
  methods: {
    teardownDtwinSocket() {
      if (this.hiveTwinSocket) {
        this.hiveTwinSocket.close();
      }
    },
    setupDtwinSocket(dtwinId) {
      if (dtwinId) {
        // TODO: add API-key here if used via public dashboard/map!
        const hiveTwinSocket = io(`${process.env.VUE_APP_API_HOST}/dtwin/${dtwinId}/states`, {
          query: `token=${localStorage.getItem('token')}`,
          allowEIO3: true,
        });

        const instance = this;
        hiveTwinSocket.on('update', function (data) {
          if (instance.statesValuesUpdated) {
            instance.statesValuesUpdated(data.states);
          }
        });
        this.hiveTwinSocket = hiveTwinSocket;
      }
    },
  },
};
